"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioPlayer = void 0;
const react_1 = require("react");
exports.AudioPlayer = (0, react_1.memo)((0, react_1.forwardRef)(({ src, autoPlay, onTimeUpdate, onPlayStateChange, onEnded, }, ref) => {
    const [isPlaying, setIsPlaying] = (0, react_1.useState)(false);
    (0, react_1.useImperativeHandle)(ref, () => ({
        updateProgress: (newTime) => {
            if (player.current) {
                player.current.currentTime = newTime / 1000;
            }
        },
        pause,
        play,
    }));
    const player = (0, react_1.useRef)();
    const initPlayer = (0, react_1.useCallback)(() => {
        const audioPlayer = new Audio(src);
        let intervalId = null;
        audioPlayer.preload = "auto";
        audioPlayer.addEventListener("play", () => {
            setIsPlaying(true);
            intervalId = setInterval(() => {
                if (onTimeUpdate) {
                    onTimeUpdate(audioPlayer.currentTime * 1000);
                }
            }, 100);
        });
        audioPlayer.addEventListener("pause", () => {
            setIsPlaying(false);
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
        });
        audioPlayer.addEventListener("ended", () => {
            onEnded === null || onEnded === void 0 ? void 0 : onEnded();
            setIsPlaying(false);
        });
        player.current = audioPlayer;
    }, [onEnded, onTimeUpdate, src]);
    (0, react_1.useEffect)(() => {
        initPlayer();
        return () => {
            // cleanup
            if (player.current) {
                player.current.pause();
                player.current.src = "";
                player.current.load();
                player.current = undefined;
            }
        };
    }, [initPlayer, src]);
    const play = (0, react_1.useCallback)(() => {
        if (player.current && !isPlaying) {
            player.current.play();
        }
    }, [isPlaying]);
    const pause = (0, react_1.useCallback)(() => {
        if (player.current && isPlaying) {
            player.current.pause();
        }
    }, [isPlaying]);
    (0, react_1.useEffect)(() => {
        if (autoPlay && player.current) {
            player.current.play().catch(() => {
                const listener = () => {
                    var _a;
                    (_a = player.current) === null || _a === void 0 ? void 0 : _a.play();
                    document.removeEventListener("click", listener);
                };
                document.addEventListener("click", listener);
            });
        }
    }, [autoPlay, src]);
    (0, react_1.useEffect)(() => {
        onPlayStateChange === null || onPlayStateChange === void 0 ? void 0 : onPlayStateChange(isPlaying);
    }, [isPlaying, onPlayStateChange]);
    return null;
}));
exports.AudioPlayer.displayName = "AudioPlayer";
